window._ = require('lodash')

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.baseURL = window.location.origin

// Add CSRF token to all axios requests
let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js')

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: 'ionbec_key',
  wsHost: window.location.hostname,
  wsPort: window.location.protocol === 'https:' ? 443 : (window.location.port || 3000),
  wssPort: window.location.protocol === 'https:' ? 443 : (window.location.port || 3000),
  forceTLS: window.location.protocol === 'https:',
  disableStats: true,
  // Pusher selects its WebSocket strategy by "ws"; forceTLS upgrades it to WSS.
  enabledTransports: ['ws', 'wss'],
  authEndpoint: '/broadcasting/auth',
})
